import { motion } from "framer-motion";

// Sections fade + rise into view. Uses IntersectionObserver
// via framer-motion's whileInView.
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  as: Tag = "div",
  className = "",
  amount = 0.2,
  ...rest
}) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1], delay }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
